import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';
import useTenantState from '@/states/tenant.state';
import type { StepProgressData, ActivityItem } from '@/components/pages/dashboard/dashboard.types';

export const useStepProgress = () => {
  const { currentTenant } = useTenantState();
  return useQuery<StepProgressData>({
    queryKey: ['step-progress', currentTenant?.id],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        `${env.apiTasklistBaseUrl}/api/v1/compro/company-profile/${currentTenant!.id}/step-progress`,
      );
      return data.data;
    },
    enabled: !!currentTenant?.id,
  });
};

export const useActivities = (limit = 10) => {
  const { currentTenant } = useTenantState();
  return useQuery<ActivityItem[]>({
    queryKey: ['activities', currentTenant?.id, limit],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        `${env.apiTasklistBaseUrl}/api/v1/compro/activities/${currentTenant!.id}`,
        { params: { limit } },
      );
      return data.data;
    },
    enabled: !!currentTenant?.id,
  });
};
